import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../colors';

export const AllEventsPageStyled = {
  Container: styled(Grid)<any>`
    display: flex;
    justify-content: center;
    background: ${Colors.PrimaryBackground};
    padding: 34px;
    width: 100%;
    flex-direction: column;
  `
};

